import { stateKey } from 'utils';
import reducer from './reducers';

const STATE_KEY = stateKey(reducer);

const selectOpen = state => state[STATE_KEY].open;

const selectHttpError = state => state[STATE_KEY].httpError;

export default {
  selectOpen,
  selectHttpError,
};
